var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM8 14.9677C4.17097 14.9677 1.03226 11.8677 1.03226 8C1.03226 4.17097 4.13226 1.03226 8 1.03226C11.829 1.03226 14.9677 4.13226 14.9677 8C14.9677 11.829 11.8677 14.9677 8 14.9677ZM11.0581 5.76452L8.82258 8L11.0581 10.2355C11.2097 10.3871 11.2097 10.6323 11.0581 10.7839L10.7839 11.0581C10.6323 11.2097 10.3871 11.2097 10.2355 11.0581L8 8.82258L5.76452 11.0581C5.6129 11.2097 5.36774 11.2097 5.21613 11.0581L4.94194 10.7839C4.79032 10.6323 4.79032 10.3871 4.94194 10.2355L7.17742 8L4.94194 5.76452C4.79032 5.6129 4.79032 5.36774 4.94194 5.21613L5.21613 4.94194C5.36774 4.79032 5.6129 4.79032 5.76452 4.94194L8 7.17742L10.2355 4.94194C10.3871 4.79032 10.6323 4.79032 10.7839 4.94194L11.0581 5.21613C11.2065 5.36774 11.2065 5.6129 11.0581 5.76452Z",
    fill: "#FAD3D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.3054027d.svg";
export { ForwardRef as ReactComponent };